import { IS_ANDROID, IS_IOS, IS_MOBILE } from '@repo/common-utils';

export const openKakaoTalk = (cxId: string) => {
  if (IS_MOBILE) {
    const kakaoLink = `kakaotalk://me/cert/sign?tx_id=${cxId}`;
    window.location.href = kakaoLink;
  }
};

// 카카오톡 인앱브라우저에서 외부 브라우저로 열기
export const openInExternalBrowser = (url: string) => {
  if (IS_ANDROID) {
    window.location.href = `intent://${url.replace(/^https?:\/\//, '')}#Intent;scheme=https;package=com.android.chrome;end`;
  } else if (IS_IOS) {
    window.location.href = `kakaotalk://web/openExternal?url=${encodeURIComponent(url)}`;
  }
};
